<template>
  <div class="now">
    <app-page-title>Beliebte Personen</app-page-title>

    <app-loader v-if="loading && page === 1" />

    <app-person-card :items="getPeople" />

    <v-container v-if="getPeople.pages !== page && getPeople.people.length !== 0">
      <v-layout row>
        <v-flex>
          <div class="text-xs-center">
            <v-btn
              flat
              :loading="loading"
              @click="loadMore"
            >
              Mehr bitte!
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from '../components/PageTitle.vue';
import PersonCard from '../components/PersonCard.vue';

export default {
  components: {
    appPageTitle: PageTitle,
    appPersonCard: PersonCard,
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    ...mapState({
      getPeople(state) {
        return state.people.searchData;
      },
    }),
    loading() {
      return this.$store.getters.loading;
    },
  },
  created() {
    this.$store.dispatch('getPopularPeople', { page: this.page });
  },
  methods: {
    loadMore() {
      this.page++;
      this.$store.dispatch('getPopularPeople', {
        page: this.page,
      });
    },
  },
};
</script>
